/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "button_add": [{
    "type": 0,
    "value": "Agregar"
  }],
  "button_remove_all": [{
    "type": 0,
    "value": "Eliminar todo"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var esCO = Object.assign(TranslationProviderComponent, {
  translations
});

export { esCO as e };
//# sourceMappingURL=es-CO-CFlVHWMC.js.map
